import React, { useState } from "react";
import "./../assets/css/modal.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import bannerImage from "./../assets/banner/portada.jpg";
import imgVertical from "./../assets/banner/imgvertical.jpg";
import logvefase from "./../assets/banner/logo-negro.webp";
import { FaAccessibleIcon } from 'react-icons/fa';
import Banner from "../components/Banner";
import AccessibilityModal from './../components/AccessibilityModal';

const Comunidad = () => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
     <div className="micolor-jm">
      <Header />
      <button className="floating-button" onClick={toggleModal}>
      <img
               src={require("../assets/clientes/iconoaccesibilidad.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "50px",
                height:"50px",
              
              }}
            />
      </button>

      <AccessibilityModal isOpen={showModal} toggle={toggleModal} />
    
     
    
      <div className="container">
        <div className="row row-jm">
         
      

          <div className="col-md-6 col-sm-12 mt-5 mb-5">
            <h2 className="mt-4 sobre-nosotras-title">COMUNIDAD</h2>
          </div>
          <div
            className="row text-center"
            style={{ paddingLeft: "5%", paddingRight: "5%" }}
          >
            <div className="row">
              <div
                className="col-md-6 col-sm-12"
                
              >
                <img
                   src={require("../assets/home/comunidad.png")}
                  alt="Imagen vertical"
                  className="img-vertical"
                  style={{
                    width: "100%",
                    height: "100%",
                    marginTop: "-4%",
                  }}
                />
              </div>
              <div className="col-md-6 col-sm-12">
                <h2 className="mt-4 text-center mb-2" style={{ color: "#000" }}>
                  Únete a nuestra comunidad
                </h2>
                <p
                  className="mitexto text-center mt-2"
                  style={{ color: "#000", fontSize: 16 }}
                >
                  <strong>Te invitamos a ser parte de nuestra comunidad:</strong> un espacio para compartir ideas, recursos y experiencias sobre Accesibilidad, Diseño Universal e Inclusión.
                </p>
                <p
                  className="mitexto text-center mt-2"
                  style={{ color: "#000", fontSize: 16 }}
                >
                  Únete a nuestro grupo de WhatsApp y conecta con personas que, como tú, están comprometidas con construir entornos más accesibles. ¡Te esperamos!
                </p>
                <button 
  className="contact-button mt-1 mb-3"
  onClick={() => window.open("https://docs.google.com/forms/d/1iZjINkMSwPujYet28WNRrMhYf0L6k1nRrHaOqbht-p4/prefill", "_blank")}
>
  UNIRME
</button>
               
              </div>
            </div>
          </div>

          
          <div className="col-md-12 col-sm-12 mt-5 mb-5"></div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Comunidad;